import type { EventListPageTypeString } from '~/composables/types/strapiEventListPage'
import { EventListPageType } from '~/composables/types/strapiEventListPage'
import { useEventListPageType } from '~/composables/transactionalPage/useEventListPageType'

interface EventListPageSlugs {
  pageType: EventListPageTypeString
  locationSlug: string | undefined
  categorySlug: string
  generalSlug: string | undefined
  tagSlug: string | undefined
}

export const useEventListPageSlugs = (
  explicitPageType?: EventListPageTypeString
): EventListPageSlugs => {
  const route = useRoute()
  const { t } = useI18n()

  const pageType = explicitPageType ?? useEventListPageType()

  let locationSlug: string | undefined = route?.params?.location?.toString()
  const categorySlug = route.params?.category?.toString() || ''
  let generalSlug = route.params?.slug?.toString()
  let tagSlug = generalSlug

  if (pageType === EventListPageType.TEAMEVENT) {
    const prefix = t('eventListPage.teamEventSlugPrefix')
    generalSlug = `${prefix}-${locationSlug}`
    tagSlug = `${prefix}-${locationSlug}`
    locationSlug = undefined
  }

  return { pageType, locationSlug, categorySlug, generalSlug, tagSlug }
}
